import React from 'react';
import { ITabsProps } from './Tabs';
import { DEFAULT_BUTTON_VARIANT } from '../Button/Button';

export interface ITabsContextProps extends ITabsProps {
  active?: number;
  setActive: (active: number) => void;
}

export const TabsContext = React.createContext<ITabsContextProps>({
  setActive: /* istanbul ignore next */ () => {},
  underline: false,
  variant: DEFAULT_BUTTON_VARIANT
});
